import React, {Component} from 'react';

export class App extends Component {
    render() {
        const {Template} = require('slp-template');
        return (
            <Template />
        );
    }
}
